export const TRANSFER_CONFIRMATION_START =
  'TRANSFER_CONFIRMATION_START';
export const TRANSFER_CONFIRMATION_SUCCESS =
  'TRANSFER_CONFIRMATION_SUCCESS';
export const TRANSFER_CONFIRMATION_ERROR =
  'TRANSFER_CONFIRMATION_ERROR';
export const TRANSFER_CONFIRMATION_END = 'TRANSFER_CONFIRMATION_END';
export const CLEAR_TRANSFER_CONFIRMATION_STORE =
  'CLEAR_TRANSFER_CONFIRMATION_STORE';
